import stringHelpers from '@/helpers/string-helpers'
import refHelpers from '@/helpers/ref-helpers'
import eventHelpers from '@/helpers/event-helpers'
import urlHelpers from '@/helpers/url-helpers'
import dateHelpers from '@/helpers/date-helpers'
import mathHelpers from '@/helpers/number-helpers'
import Vue from 'vue'

export default {
   install: () => {
      Vue.prototype.stringHelpers = stringHelpers
      Vue.stringHelpers = stringHelpers

      Vue.prototype.refHelpers = refHelpers
      Vue.refHelpers = refHelpers

      Vue.prototype.eventHelpers = eventHelpers
      Vue.eventHelpers = eventHelpers

      Vue.prototype.urlHelpers = urlHelpers
      Vue.urlHelpers = urlHelpers

      Vue.prototype.dateHelpers = dateHelpers
      Vue.dateHelpers = dateHelpers

      Vue.prototype.mathHelpers = mathHelpers
      Vue.mathHelpers = mathHelpers
   }
}
